//log level for JS console
export const logConstants = {
	INFO: 'info',
	ERROR: 'error',
	DEBUG: 'debug',
} as const;

export type logConstantsType = (typeof logConstants)[keyof typeof logConstants];

//log level for native
export const TraceKind = {
	Message: '2',
	Error: '8',
	Debug: '16',
} as const;

export type TraceKindType = (typeof TraceKind)[keyof typeof TraceKind];

//AOT category for native
export const AotCategory = {
	Error: '1',
	Info: '2',
	Warning: '64',
	Failure: '128',
} as const;

export type AotCategoryType = (typeof AotCategory)[keyof typeof AotCategory];

export const aotConstants = {
	Authentication: 'Authentication:',
} as const;

export enum AppName {
	WORKSPACE = 'workspace',
	CITRIXBROWSER = 'citrixBrowser',
	SETTINGS = 'settings',
}
